import { render, staticRenderFns } from "./CustomerCover.vue?vue&type=template&id=d8e3a66c"
import script from "./CustomerCover.vue?vue&type=script&lang=js"
export * from "./CustomerCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports